export class S1UserID{
    userId : number;
}